import { COLLECTIONS } from '__constants__'
import { doc } from 'firebase/firestore'
import { firestore } from 'services/firebase'
import { useDocumentData } from 'react-firebase-hooks/firestore'
import { useMemo } from 'react'

const useGetBrand = (brandId) => {
  const querySnapshot = useMemo(
    () => (brandId ? doc(firestore, COLLECTIONS.BRANDS, brandId) : null),
    [brandId]
  )
  return useDocumentData(querySnapshot)
}

export default useGetBrand
